import { render, staticRenderFns } from "./DealersBrands.vue?vue&type=template&id=8229ee18&"
import script from "./DealersBrands.vue?vue&type=script&lang=js&"
export * from "./DealersBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports